var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Roboto Medium;font-style:normal;font-weight:400;src:local(\"Roboto Medium\"),url(" + escape(require("../assets/Roboto-Medium.woff")) + ") format(\"woff\")}@font-face{font-family:open-sans-semibold;src:url(" + escape(require("../../../common/assets/opsnSansFonts/opensans-semibold-webfont.woff2")) + ") format(\"woff2\"),url(" + escape(require("../../../common/assets/opsnSansFonts/opensans-semibold-webfont.woff")) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:open-sans-regular;src:url(" + escape(require("../../../common/assets/opsnSansFonts/opensans-regular-webfont.woff2")) + ") format(\"woff2\"),url(" + escape(require("../../../common/assets/opsnSansFonts/opensans-regular-webfont.woff")) + ") format(\"woff\");font-weight:400;font-style:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c7fd7c7","scoped":false,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/App.vue
// module id = 431
// module chunks = 0